import { render } from "./Notice.vue?vue&type=template&id=ba0eaaec&scoped=true&ts=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"

import "./Notice.vue?vue&type=style&index=0&id=ba0eaaec&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0eaaec"]])

export default __exports__